import { render } from "./TemplatesDownload.vue?vue&type=template&id=0d50a7ae&scoped=true&ts=true"
import script from "./TemplatesDownload.vue?vue&type=script&lang=ts"
export * from "./TemplatesDownload.vue?vue&type=script&lang=ts"

import "./TemplatesDownload.vue?vue&type=style&index=0&id=0d50a7ae&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d50a7ae"]])

export default __exports__